module.exports = __webpack_public_path__ + "img/hrb_dd@2x.969d4e2a.png";